import {Box3, Vector3} from "three";

export function getCenter(object3d){

    const box = new Box3().setFromObject(object3d);
    return box.getCenter(new Vector3());

}

export function getSizeBox (object3d){

    const box = new Box3().setFromObject(object3d);
    return  box.getSize(new Vector3())

}

export function getRealHeight (object3d){

    const box = new Box3().setFromObject(object3d);
    return  Math.abs(box.max.y - box.min.y)

}

export function getRealWidth (object3d){

    const box = new Box3().setFromObject(object3d);
    return  Math.abs(box.max.x - box.min.x)

}

export function getSize (object3d){

    const box = new Box3().setFromObject(object3d);
    return  box.getSize(new Vector3()).length();

}